// extracted by mini-css-extract-plugin
export var section = "connect-module--section--3lAR7";
export var inner = "connect-module--inner--1bva7";
export var jsAnimInit = "connect-module--jsAnimInit--17F4G";
export var content = "connect-module--content--_HKf5";
export var title = "connect-module--title--1FZJG";
export var btn = "connect-module--btn--wrC-n";